<template>
  <div
    class="
      login
      is-flex
      is-flex-direction-column
      is-justify-content-center
      is-align-items-center
    "
  >
    <div
      class="
        is-flex
        is-flex-direction-column
        is-align-items-center
        is-justify-content-center
      "
    >
      <img alt="movida logo" src="@/assets/logo.svg" />
      <h1 class="is-size-2 has-text-weight-bold pb-5">{{ appTitle }}</h1>
    </div>
    <div class="card">
      <div class="card-content">
        <div class="content">
          <!-- Feedback do m�todo ativo -->
          <div v-if="activeMethod" class="notification custom-notification mb-4">
            <p>
              <strong>Método atual:</strong> {{ getMetodoMFAName(activeMethod) }}
              <br>
              <small>Solicitado em: {{ formatTime(lastRequestTime) }}</small>
            </p>
          </div>

          <!-- Contador para opõees alternativas -->
          <div v-if="!showNewButton" class="has-text-centered mb-4">
            <p class="is-size-6">
              Opções alternativas disponíveis em: {{ countdown }} segundos
            </p>
          </div>

          <form v-if="!sendMFA" @submit.prevent="submit">
            <div class="field">
              <label style="font-size: 12px;" class="label" v-if="metodo_mfa === 1">Token enviado por E-mail</label>
              <label style="font-size: 12px;" class="label" v-else-if="metodo_mfa === 2">Token enviado via SMS</label>
              <label style="font-size: 12px;" class="label" v-else-if="metodo_mfa === 3">Utilizar Token gerado pelo App</label>
              <label style="font-size: 12px;" class="label" v-else-if="metodo_mfa === 4">Token enviado via WhatsApp</label>
              <label class="label">Token MFA</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="form.mfatoken"
                  placeholder="Insira o token MFA"
                />
              </div>
            </div>
            <div class="buttons">
              <b-button
                class="is-fullwidth"
                label="Acessar"
                type="is-primary"
                native-type="submit"
                icon-left="check"
              />
            </div>
            <div v-if="showNewButton">
              <p class="is-size-6 has-text-centered my-2" v-if="outrosMetodosMFA && outrosMetodosMFA.length > 0">
                Caso não receba o token pelo método padrão, solicite um novo token com os métodos abaixo
              </p>
              <p class="is-size-6 has-text-centered my-2" v-else>
                O usuário não possui outros métodos MFA disponíveis
              </p>
              <div class="buttons is-flex is-flex-wrap-wrap is-justify-content-center" v-if="outrosMetodosMFA && outrosMetodosMFA.length > 0">
                <b-button
                  v-for="method in outrosMetodosMFA"
                  :key="method.MfaMetodoID"
                  class="is-fullwidth"
                  :label="`Token enviado por ${method.Metodo}`"
                  type="is-primary"
                  @click="requestNewToken(method.MfaMetodoID)"
                />

                <!-- Botão condicional para o método MfaMetodoID=3 se ele não for padrão e não existir na lista -->
                <b-button
                  v-if="deveMostrarBotaoApp"
                  key="3"
                  class="is-fullwidth"
                  label="Token enviado por app"
                  type="is-primary"
                  @click="requestNewToken(3)"
                />
              </div>
            </div>
          </form>
          <div v-else>
            <b-message type="is-success" has-icon>
              Token validado com sucesso.
            </b-message>
          </div>
        </div>
        <b-loading
          :is-full-page="isFullPage"
          v-model="isLoading"
          :can-cancel="true"
        ></b-loading>
      </div>
    </div>
    <Footer></Footer>
    <!-- Modal para enviar e validar novo token -->
    <b-modal v-model="showModal" :has-modal-card="true">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Token enviado por {{ getMetodoMFAName(metodo_mfa) }}</p>
          <button class="delete" aria-label="Fechar" @click="closeModal"></button>
        </header>
        <section class="modal-card-body">
          <label class="label">Novo Token MFA</label>
          <div class="control">
            <input class="input" type="text" v-model="novoToken" placeholder="Insira o novo token MFA" />
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" label="Enviar" type="is-primary" @click="enviarNovoToken" />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { flash } from "@/mixins/flash";
import { redirectMixin } from "@/mixins/redirectMixin";
import Footer from "@/components/Layout/FooterLogin.vue";
import state from "@/modules/auth/store/state";
import AppValidateTokenView from "@/modules/valid-token-mfa/pages/AppValidateTokenView.vue";
import {
  decodeTokenPayload,
  resolveUserIdFromToken
} from "@/modules/valid-token-mfa/utils/tokenPayload";

export default {
  components: {
    Footer
  },
  mixins: [flash, redirectMixin],
  data() {
    return {
      isLoading: false,
      isFullPage: true,
      appTitle: process.env.VUE_APP_TITLE,
      form: {
        mfatoken: null,
      },
      sendMFA: false,
      showModal: false,
      showNewButton: false,
      novoToken: "",
      metodo_mfa: state.mfa_padrao.MfaMetodoID,
      outrosMetodosMFA: state.outros_metodos_mfa,
      novoMetodoMFA: null,
      redirect: state.redirect,
      params: state.params,
      activeMethod: null,
      tokenRequested: false,
      lastRequestTime: null,
      countdownTimer: null,
      countdown: 20
    };
  },
  computed: {
    deveMostrarBotaoApp() {
      const appNaoEhPadrao = state.mfa_padrao.MfaMetodoID !== 3;
      const appNaoExisteEmOutrosMetodos = !this.outrosMetodosMFA.some(method => method.MfaMetodoID === 3);

      return appNaoEhPadrao && appNaoExisteEmOutrosMetodos;
    }
  },
  mounted() {
    // Recupera os dados do sessionStorage
    const SAMLResponse = sessionStorage.getItem("SAMLResponse");
    const RelayState = sessionStorage.getItem("RelayState");
    const destination = sessionStorage.getItem("destination");

    // Limpa a URL após a navegação
    this.clearUrlParams();
    
    if (!this.$cookies.get("token_user")) {
      this.redirectToLogin();
      return;
    }

    // Inicia o método padrão
    this.activeMethod = state.mfa_padrao.MfaMetodoID;
    this.lastRequestTime = new Date();
    
    // Inicia o contador para mostrar opções alternativas
    this.startCountdown();
    
    this.isMethodApp(state.mfa_padrao.MfaMetodoID);
  },
  methods: {
    clearUrlParams() {
      const url = new URL(window.location.href);
      url.search = ""; // Remove todos os parâmetros da query
      window.history.replaceState({}, document.title, url.toString());
    },
    register(methodId) {
      this.novoMetodoMFA = methodId;

      const data = {
        userId: state.user.id,
        methodId: this.novoMetodoMFA,
      };

      this.isLoading = true;

      return this.$http
        .post(process.env.VUE_APP_BFF_URL + "v2/movida/mfa/register", data, {
          headers: {
            Authorization: `Bearer ${$cookies.get("token_app")}`,
          },
        })
        .then((res) => {
          this.isLoading = false;
          if (this.novoMetodoMFA === 3) {
            // Mostrar o modal para validar o token de app
            this.$buefy.modal.open({
              parent: this,
              component: AppValidateTokenView,
              hasModalCard: true,
              trapFocus: true,
            });
          } else if (this.novoMetodoMFA === 4) {
            // Mostrar o modal para validar o token do WhatsApp
            this.$buefy.modal.open({
              parent: this,
              component: WhatsAppView,
              hasModalCard: true,
              trapFocus: true,
            });
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.flashError(err, "is-bottom", 5000);
        });
    },
    setDefault(methodId) {
      const data = {
        userId: state.user.id,
        methodId: methodId,
      };
      return this.$http
        .post(process.env.VUE_APP_BFF_URL + "v2/movida/mfa/default", data, {
          headers: {
            Authorization: `Bearer ${this.$cookies.get("token_app")}`,
          },
        })
        .catch((err) => {
          this.isLoading = false;
          this.flashError(err, "is-bottom", 5000);
        });
    },
    enviarToken(metodoMFA) {
      if (this.isContemMFA(metodoMFA)) {
        if (metodoMFA !== 3) {
          // Envia o token sem definir como padrão
          this.sendTokenMfa(metodoMFA, this.$cookies.get("token_user"))
            .then(() => {
              this.flashSuccess(`Token enviado por ${this.getMetodoMFAName(metodoMFA)}`, "is-bottom");
              // Atualiza o método atual após o envio
              this.metodo_mfa = metodoMFA;
            })
            .catch((err) => {
              this.flashError(err, "is-bottom", 5000);
              this.activeMethod = null;
              this.tokenRequested = false;
            });
        }
      } else {
        this.register(metodoMFA);
      }
    },
    sendTokenMfa(metodo, token) {
      const userId = resolveUserIdFromToken(token, state.user && state.user.id);
      if (userId == null) {
        this.redirectToLogin();
        return Promise.reject(new Error("Sessão expirada. Faça login novamente."));
      }

      const mfa_request = {
        userId,
        methodId: metodo
      };
      
      this.isLoading = true;
      return this.$http
        .post(process.env.VUE_APP_BFF_URL + "v2/movida/mfa/token", mfa_request, {
          headers: {
            Authorization: `Bearer ${this.$cookies.get("token_app")}`
          }
        })
        .then((res) => {
          this.isLoading = false;
          this.flashSuccess(`Token enviado por ${this.getMetodoMFAName(metodo)}`, "is-bottom");
        })
        .catch((err) => {
          this.isLoading = false;
          this.flashError(err, "is-bottom", 5000);
          throw err;
        });
    },
    decodeToken(token) {
      return decodeTokenPayload(token);
    },
    redirectToLogin(message = "Sessão expirada. Faça login novamente.") {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.flashError(message, "is-bottom", 5000);
      this.$router.push({ name: "login" }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error("Erro na navegação:", err);
        }
      });
    },
    isMethodApp(metodoMfa) {
      if (metodoMfa != 3) {
        const token = this.$cookies.get("token_user");
        if (!token) {
          this.redirectToLogin();
          return;
        }

        this.sendTokenMfa(metodoMfa, token).catch(() => {});
      }
    },
    submit() {
      this.isLoading = true;

      const token = this.$cookies.get("token_user");
      const userId = resolveUserIdFromToken(token, state.user && state.user.id);
      const checkMfa = this.isContemMFA(state.mfa_padrao.MfaMetodoID);

      if (userId == null) {
        this.redirectToLogin();
        this.isLoading = false;
        return;
      }

      const sessionUserId = state.user && state.user.id;
      if (sessionUserId && sessionUserId != userId) {
        this.flashError("Usuário não corresponde com o usuário do Token", "is-bottom", 5000);
        this.isLoading = false;
        return;
      }

      if (checkMfa) {
        this.validate(userId, this.metodo_mfa, this.form)
          .then(() => {
            this.sendMFA = true;
            this.isLoading = false;
            this.flashSuccess("Token MFA validado com sucesso.", "is-bottom");

            // Verifica se é um login SAML através dos parâmetros da rota
            const isSAML = this.$route.query.isSAML === 'true';
            const destination = this.$route.query.destination;

            if (isSAML && destination) {
              // Recupera as informações do SAML do sessionStorage
              const SAMLResponse = sessionStorage.getItem("SAMLResponse");
              const RelayState = sessionStorage.getItem("RelayState");
              
              // Faz o redirecionamento SAML
              this.postSAML(destination, {
                SAMLResponse: SAMLResponse,
                RelayState: RelayState
              });

              // Remove os dados do sessionStorage após o uso
              sessionStorage.removeItem("SAMLResponse");
              sessionStorage.removeItem("RelayState");
              sessionStorage.removeItem("destination");
            } else {
              // Recupera os dados SAML do sessionStorage (fluxo antigo)
              const SAMLResponse = sessionStorage.getItem("SAMLResponse");
              const RelayState = sessionStorage.getItem("RelayState");
              const oldDestination = sessionStorage.getItem("destination");

              // Verifica se há parâmetros SAML para redirecionamento
              if (SAMLResponse && RelayState && oldDestination) {
                this.redirectToSAML(SAMLResponse, RelayState, oldDestination);
                
                // Remove os dados do sessionStorage após o uso
                sessionStorage.removeItem("SAMLResponse");
                sessionStorage.removeItem("RelayState");
                sessionStorage.removeItem("destination");
              } else {
                // Se não há parâmetros SAML, redireciona para a página padrão
                if(state.mfa_validate){
                  this.redirectPage();
                }
              }
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.flashError(err, "is-bottom", 5000);
          });
      } else {
        this.flashError("Método MFA indisponível para este usuário.", "is-bottom", 5000);
        this.isLoading = false;
      }
    },
    isContemMFA(metodoMfa) {
      if (!metodoMfa) return false;

      if (metodoMfa === state.mfa_padrao.MfaMetodoID) {
        return true;
      }
      
      return state.outros_metodos_mfa.some(metodo => metodo.MfaMetodoID === metodoMfa);
    },
    validate(id, metodo, payload) {
      const request = {
        userId: id,
        methodId: metodo,
        token: payload.mfatoken,
      };
      return this.$http
        .post(process.env.VUE_APP_BFF_URL + "v2/movida/mfa/token-validate", request, {
          headers: {
            Authorization: `Bearer ${this.$cookies.get("token_app")}`,
          },
        })
        .then((res) => {
          this.isLoading = false;
          this.$store.dispatch("auth/ActionLoadSession");
          if (res.body.status) {
            this.$store.dispatch("auth/ActionSetValidateMFA", {
              mfa_validate: res.body.status,
            });
          }
        })
        .catch((err) => {
          throw err.response.data.message;
        });
    },
    openModal(metodoMFA) {
      this.novoMetodoMFA = metodoMFA;
      this.enviarToken(metodoMFA);
      this.metodo_mfa = metodoMFA;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    getMetodoMFAName() {
      if (!Array.isArray(this.outrosMetodosMFA)) return '';
      
      const metodo = this.outrosMetodosMFA.find(m => m.MfaMetodoID === this.metodo_mfa);
      return metodo ? metodo.Metodo : '';
    },
    enviarNovoToken() {
      this.metodo_mfa = this.novoMetodoMFA;
      this.form.mfatoken = this.novoToken;

      this.submit();
      this.showModal = false;
      this.novoToken = "";
    },
    redirectToSAML(SAMLResponse, RelayState, destination) {
      if (destination) {
        this.postSAML(destination, { SAMLResponse, RelayState });
      } else {
        this.flashError('URL de destino inexistente', "is-bottom", 5000);
      }
    },
    postSAML(path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];
          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    },
    startCountdown() {
      this.countdown = 20;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.showNewButton = true;
        }
      }, 1000);
    },
    formatTime(date) {
      if (!date) return '';
      return new Date(date).toLocaleTimeString();
    },
    requestNewToken(methodId) {
      // Atualiza estado
      this.activeMethod = methodId;
      this.tokenRequested = true;
      this.lastRequestTime = new Date();
      this.metodo_mfa = methodId; // Atualiza o método atual
      
      // Envia token
      this.enviarToken(methodId);
    }
  }
}
</script>

<style scoped>
.notification.custom-notification {
  background-color: #F47920 !important;
  color: white !important;
}

.notification.custom-notification strong {
  color: white !important;
}

.notification.custom-notification small {
  color: rgba(255, 255, 255, 0.9) !important;
}
</style>
